import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('$consolidatedBillingOrders', ConsolidatedBillingOrdersObjectFactory);

/* @ngInject */
function ConsolidatedBillingOrdersObjectFactory($bringozFactory: $bringozFactory,
                                                ConsolidateBillingOrdersAPI: BringozApi,
                                                Consolidated_BillingOrders_DS: DataStoreConfig,
                                                ConsolidatedBillingOrders_PN: PushNotificationsConfig) {
  function $consolidatedBillingOrders(id: string) {
    return $bringozFactory(id, ConsolidateBillingOrdersAPI, Consolidated_BillingOrders_DS, ConsolidatedBillingOrders_PN)
  }

  return $consolidatedBillingOrders;
}
